import { FETCH_POINTS, CLEAN_POINTS, DELETE_POINT } from '../actions/types';

const POINTS_DEFAULT_STATE = {};

const PointsReducer = (state = POINTS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_POINTS:
            return payload;

        case CLEAN_POINTS:
        case DELETE_POINT:
            return POINTS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default PointsReducer;
